<template>
  <div class="">
    <div class="columns">
      <div class="column is-two-fifths">
        <div class="content">
          <dl>
            <dt>Planned Arrival</dt>
            <dd>
              {{ formattedDate }}
              <br/>
              <span class="is-size-7">{{ formattedTime }}</span>
            </dd>
          </dl>
        </div>
      </div>

      <div class="column is-two-fifths">
        <div class="content">
          <dl>
            <dt>Actual Arrival</dt>
            <dd>
              {{ formattedMilestoneDate }}
              <br/>
              <span class="is-size-7">{{ formattedMilestoneTime }}</span>
            </dd>
          </dl>
        </div>
      </div>
    </div>

    <div class="columns is-multiline">
      <div class="column">
        <div class="content">
          <dl>
            <dt>Facility Name</dt>
            <dd> {{point.address.facilityName}} </dd>
          </dl>
        </div>
      </div>

      <div class="column">
        <div class="content">
          <dl>
            <dt>Address</dt>
            <dd>
              {{ point.address.street1 }}
              <br/>
              {{ point.address.city }} {{ point.address.state }}, {{ point.address.zip }}
            </dd>
          </dl>
        </div>
      </div>

      <div class="column is-one-fifth">
        <div class="content">
          <dl>
            <dt>Dock</dt>
            <dd> {{point.companyJobPointDock}} </dd>
          </dl>
        </div>
      </div>

      <div class="column is-full" v-if="point.CompanyRolodexContactKey1 || point.CompanyRolodexContactKey2">
        <div class="content">
          <dl>
            <dt>Contacts</dt>
            <dd>
              <table class="table is-narrow" >
                <thead>
                <tr>
                  <th>Full name</th>
                  <th>Phone</th>
                  <th>Email</th>
                </tr>
                </thead>
                <tbody>
                <tr v-if="point.CompanyRolodexContactKey1">
                  <td> {{ point.CompanyRolodexContactKey1.companyRolodexContactFullName }} </td>
                  <td v-if="point.CompanyRolodexContactKey1.companyRolodexContactPhones.length">
                    {{ point.CompanyRolodexContactKey1.companyRolodexContactPhones[0].companyRolodexContactPhoneDigits }}
                  </td>
                  <td v-else></td>
                  <td> {{ point.CompanyRolodexContactKey1.companyRolodexContactEmailAddress }} </td>
                </tr>
                <tr v-if="point.CompanyRolodexContactKey2">
                  <td> {{ point.CompanyRolodexContactKey2.companyRolodexContactFullName }} </td>
                  <td v-if="point.CompanyRolodexContactKey2.companyRolodexContactPhones.length">
                    {{ point.CompanyRolodexContactKey2.companyRolodexContactPhones[0].companyRolodexContactPhoneDigits }}
                  </td>
                  <td v-else></td>
                  <td> {{ point.CompanyRolodexContactKey2.companyRolodexContactEmailAddress }} </td>
                </tr>
                </tbody>
              </table>
            </dd>
          </dl>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import { format } from 'date-fns'
export default {
  name: 'JobPointInformation',
  props: {
    point: {
      type: Object,
      required: true
    }
  },

  computed: {
    formattedDate() {
      const dateFormat = 'MMM DD, YYYY'

      const earliestDate = format(this.point.companyJobPointDateEarliest, dateFormat)
      const latestDate = format(this.point.companyJobPointDateLatest, dateFormat)

      let date = earliestDate
      if (earliestDate !== latestDate) {
        date = `${earliestDate} - ${latestDate}`
      }

      return date
    },

    formattedTime() {
      const timeFormat = 'hh:mm A'

      const earliestTime = format(this.point.companyJobPointDateEarliest, timeFormat)
      const latestTime = format(this.point.companyJobPointDateLatest, timeFormat)

      return `${earliestTime} - ${latestTime}`
    },

    formattedMilestoneDate() {
      const dateFormat = 'MMM DD, YYYY'
      const rawDate = this.point.checkInMileStone.companyJobExecutionLogEntryValue
      let formattedDate = 'Not yet available'

      if (rawDate) {
        formattedDate = format(rawDate, dateFormat)
      }

      return formattedDate
    },

    formattedMilestoneTime() {
      const timeFormat = 'hh:mm A'
      const rawDate = this.point.checkInMileStone.companyJobExecutionLogEntryValue
      let formattedTime = ''

      if (rawDate) {
        formattedTime = format(rawDate, timeFormat)
      }
      return formattedTime
    }
  }
}
</script>

<style scoped>
</style>
